import isEqual from "lodash.isequal";

/**
 * Compare two screening window object and return true if all properties are the same
 */
export default function sameScreeningWindowObject(left, right){
    return isEqual(left, right)
}